import { render, staticRenderFns } from "./YearExamContent.vue?vue&type=template&id=edc65d9c&scoped=true&lang=pug&"
import script from "./YearExamContent.vue?vue&type=script&lang=js&"
export * from "./YearExamContent.vue?vue&type=script&lang=js&"
import style0 from "./YearExamContent.vue?vue&type=style&index=0&id=edc65d9c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edc65d9c",
  null
  
)

export default component.exports